import { useState, type FC } from 'react';

import { Box, Button } from '@mui/material';

import { useSignerContext } from '@/providers/SignerProvider';
import { CampaignStatus, type Campaign } from '@/types';

import CancelCampaignDialog from './CancelCampaignDialog';

type Props = {
  campaign: Campaign;
};

const CancelCampaignSection: FC<Props> = ({ campaign }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const { signer } = useSignerContext();

  const showSection =
    campaign.status === CampaignStatus.ACTIVE &&
    campaign.launcher === signer?.address;

  return (
    <>
      {showSection && (
        <Box
          component="section"
          sx={{
            width: { xs: '100%', md: '60%' },
          }}
        >
          <Button
            variant="text"
            sx={{
              display: 'inline',
              ml: 0.5,
              p: 0,
              bgcolor: 'transparent',
              color: 'error.main',
              fontSize: 14,
              fontWeight: 700,
              lineHeight: '20px',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            onClick={() => setOpenDialog(true)}
          >
            Cancel this Campaign
          </Button>
        </Box>
      )}
      <CancelCampaignDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        campaign={campaign}
      />
    </>
  );
};

export default CancelCampaignSection;
